import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ShopUser = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
};

type AuthState = {
  token: string | null;
  user: ShopUser | null;
};

function readSession(): AuthState {
  try {
    const token = localStorage.getItem("zippyToken");
    const raw = localStorage.getItem("zippyUser");
    const user = raw ? JSON.parse(raw) : null;
    return { token, user };
  } catch (error) {
    return { token: null, user: null };
  }
}

const authSlice = createSlice({
  name: "auth",
  initialState: readSession(),
  reducers: {
    setCredentials(
      state,
      action: PayloadAction<{ token: string; user: ShopUser }>
    ) {
      state.token = action.payload.token;
      state.user = action.payload.user;
      localStorage.setItem("zippyToken", action.payload.token);
      localStorage.setItem("zippyUser", JSON.stringify(action.payload.user));
    },
    setUser(state, action: PayloadAction<ShopUser>) {
      state.user = action.payload;
      localStorage.setItem("zippyUser", JSON.stringify(action.payload));
    },
    logout(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem("zippyToken");
      localStorage.removeItem("zippyUser");
    },
  },
});

export const { setCredentials, setUser, logout } = authSlice.actions;
export default authSlice.reducer;
